//
// helpers/upto.js - make an array up to N
//

export default function upto(n) {
  return Array.apply(null, {length: n}).map((_,i) => i);
}

